<script>
export default {
  data() {
    return {
      fullscreen: false,
    }
  },

  methods: {
    toggle() {
      this.$fullscreen.toggle(this.$el.ownerDocument.querySelector('html'), {
        wrap: false,
        callback: this.fullscreenChange,
      })
    },

    fullscreenChange(fullscreen) {
      this.fullscreen = fullscreen
    },
  },
}
</script>

<template>
  <b-nav-item v-once class="d-md-down-none" @click="toggle">
    <i class="icon-frame"></i>
  </b-nav-item>
</template>
<style>
.icon-frame {
  color: #666666;
}
</style>
